/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "./Navbar";
import axios from "axios";
import CheckoutSteps from "./CheckOutProgress";
import location from "./images/location.png"
// import address from "./images/address.jpg"
// import { saveShippingAddress } from "../actions/cartActions";
// import CheckoutSteps from "../components/CheckoutSteps";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const ShippingAddress = () => {
  const [fullName, setFullName] = useState("");
  const [selected, setSelected] = useState(0)
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [savedAddresses, setSavedAddresses] = useState(null);
  const [invalidFormInput, setInvalidFormInput] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [states, setStates] = useState(["Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry"]);
  const dispatch = useDispatch();
  const { cartProducts, totalQuantities, totalPrice, myOrders, totalAmount } =
    useSelector((state) => state.cartReducer);

  const validateForm = () => {
    if (fullName === "" || mobile === "" || address === "" || city === "" || state === "" || postalCode === "") return false;
    return true;
  };

  const alert = (msg, type) => (
    <div className={`bg-${type} my-2 py-2 px-4 w-100`} style={{borderRadius:"3px"}} >{msg}</div>
  );

  if (invalidFormInput) {
    setTimeout(() => {
      setInvalidFormInput(false);
    }, 2000);
  }

  useEffect(() => {
    // console.log(JSON.parse(localStorage.getItem("shippingAddresses")));
    setSavedAddresses(JSON.parse(localStorage.getItem("shippingAddresses")) || []);
  }, []);

  const addAddressHandler = () => {
    const shippingAddress = {
      fullName: fullName,
      mobile: mobile,
      address: address,
      city: city,
      state: state,
      postalCode: postalCode,
    };
    if (validateForm()) {

      axios
        .post(
          SERVER_URL+
          "/api/saveshippingaddress",
          {
            shipping_address: shippingAddress,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("userTokenTime")).token,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          console.log("Shipping address saved!");
          localStorage.setItem("shippingAddresses", JSON.stringify(res.data.addresses.shipping_addresses));
          window.location.href = process.env.REACT_APP_LINK + "shipping"
        })
        .catch((err) => {
          console.log(err);
        });
    }
    else {
      setInvalidFormInput(true);
    }
  };

  if (!localStorage.getItem("userTokenTime")) return <Navigate to="/signin" />;
  else if (cartProducts.length === 0) return <Navigate to="/" />;

  return (
    <>
      <Navbar />
      <div className="container-z" style={{ paddingTop: "100px", backgroundColor: "white" }}>
        <CheckoutSteps step1 step2></CheckoutSteps>
        <div className="row-y" style={{ marginTop: "30px" }}>
          <div className="column1">
            <div className="shipping-temp">
              <h3>Select a delivery address</h3>
              <p>
                Is the address you'd like to use displayed below? If so, click the
                corresponding "Deliver to this address" button. Or you can enter a
                new delivery address.
              </p>
            </div>

            <div className="shipping-saved" style={{ display: "flex" }}>
              {savedAddresses &&
                savedAddresses.map((add, index) => (
                  <div className={`${selected === index ? "aselected" : ""} saved-address`}
                    onClick={() => {
                      setSelected(index);
                      localStorage.setItem(
                        "currentShippingAddress",
                        JSON.stringify(add)
                      )
                    }
                    }
                  >
                    <h5>{add.fullName}</h5>
                    <p style={{ marginBottom: "0px" }}>{add.address}</p>
                    <p style={{ marginBottom: "0px" }}>
                      {add.city}, {add.state} {add.postalCode}
                    </p>
                    <p>INDIA</p>
                    {/* <Link to="/payment">
                  <button
                    className="btn"
                    onClick={(e) => {
                      localStorage.setItem(
                        "currrentShippingAddress",
                        JSON.stringify(add)
                      );
                    }}
                  >
                    Deliver to this address
                  </button>
                </Link> */}
                  </div>
                ))}
              <div className="saved-address1" data-toggle="modal" data-target="#exampleModalCenter" style={{ border: "3px dashed #f1f1f1" }}>
                <div>
                  <img src={location} width={75} alt="" />
                </div>
                <h5>Add a new address</h5>

              </div>
            </div>

          </div>
          <div className="column2 shippingRight">
            <span className="price-heading">PRICE DETAILS ({cartProducts.length} Items)</span>
            <div className="desc-div">
              <div className="price-div">
                <div className="inner-row">
                  <div>Total MRP </div>
                  <span>₹ {totalPrice}</span>
                </div>
              </div>
              <div className="discount-div">
                <div className="inner-row">
                  <div>Discount on MRP</div>
                  <span>-₹{totalPrice - totalAmount}</span>
                </div>
              </div>
              <div className="delivery-div">
                <div className="inner-row">
                  <div>Delivery Charges</div>
                  <span><s style={{ marginRight: "5px", color: "black" }}>₹99</s>FREE</span>
                </div>
              </div>
              <div className="totalprice-div">
                <div className="inner-row">
                  <div>Total Amount</div>
                  <span>₹ {totalAmount}</span>
                </div>
              </div>
              <div className="place-order-btn">
                <Link to="/payment">
                  <div
                    className="btn"
                  //  onClick={placeOrder}
                  >
                    Proceed To Payment
                  </div>
                </Link>
              </div>
              <div className="savings">You will save ₹{totalPrice - totalAmount + 99} on this order</div>
            </div>
          </div>





          <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Add a new address</h5>
                </div>

                <div class="modal-body">

                  <form className="needs-validation" noValidate style={{ maxWidth: "600px" }}>
                {invalidFormInput && alert("All fields are necessary!", "red")}

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputFullName">Full Name</label>
                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          onChange={(e) => setFullName(e.target.value)}
                          // id="inputFullName"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputMobile">Mobile number</label>
                        <input
                          type="Number"
                          class="form-control"
                          id="inputMobile"
                          onChange={(e) => setMobile(e.target.value)}
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputAddress">Address</label>
                      <textarea
                        type="text"
                        class="form-control"
                        onChange={(e) => setAddress(e.target.value)}
                        id="inputAddress"
                        placeholder=""
                      />
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputCity">Town/City</label>
                        <input
                          type="text"
                          class="form-control"
                          onChange={(e) => setCity(e.target.value)}
                          id="inputCity"
                        />
                      </div>
                      <div class="form-group col-md-5">
                        <label for="inputState">State</label>
                        <select
                          id="inputState"
                          class="form-control"
                          onChange={(e) => {
                            setState(e.target.value);
                          }}
                        >
                          <option value="Choose" selected>Choose...</option>
                          {states && states.map((stateName) => {
                            return <option value={stateName}>{stateName}</option>
                          })}
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputZip">Pincode</label>
                        <input
                          type="number"
                          class="form-control"
                          // onWheel={ event => event.currentTarget.blur() }
                          onChange={(e) => setPostalCode(e.target.value)}
                          id="inputZip"
                        />
                      </div>
                    </div>
                    {/* <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="gridCheck" />
              <label class="form-check-label" for="gridCheck">
                Check me out
              </label>
            </div>
          </div> */}
                    {/* <Link to="/payment">
                    <button
                      disabled={fullName === "" || mobile === "" || address === "" || city === "" || state === "Choose" || postalCode === ""}
                      class="mt-3 btn btn-primary"
                      onClick={saveShippingAddress}
                    >
                      Use This Address
                    </button>
                  </Link> */}
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" onClick={addAddressHandler}>Add address</button>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  );
};

export default ShippingAddress;
